import React from 'react'
import { usePaginationFragment, useFragment, graphql } from 'react-relay'

import { useMedia } from 'tamagui'

import { EventList } from '@newComponents'

import { UserEventsPastSection_user$key } from './__generated__/UserEventsPastSection_user.graphql'
import { UserEventsPastSection_query$key } from './__generated__/UserEventsPastSection_query.graphql'

export const UserEventsPastSection = ({
  user,
  query,
}: {
  user: UserEventsPastSection_user$key
  query: UserEventsPastSection_query$key
}) => {
  const { data, hasNext, loadNext } = usePaginationFragment(
    graphql`
      fragment UserEventsPastSection_user on User
      @refetchable(queryName: "UserEventsPastSectionPaginationQuery")
      @argumentDefinitions(
        count: { type: "Int", defaultValue: 3 }
        cursor: { type: "Cursor" }
      ) {
        pastEvents: eventAttendance(
          first: $count
          after: $cursor
          timeSelection: PAST
        ) @connection(key: "UserEventsPastSection_user_pastEvents") {
          edges {
            cursor
          }

          ...EventList_eventsConnection
        }
      }
    `,
    user
  )

  const queryData = useFragment(
    graphql`
      fragment UserEventsPastSection_query on Query {
        ...EventList_query
      }
    `,
    query
  )

  const media = useMedia()

  return (
    <EventList
      eventsConnection={data.pastEvents}
      query={queryData}
      hasNext={hasNext}
      loadNext={loadNext}
      forceVertical={media.md}
    />
  )
}
